"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var msPerFrame = 16;
var sampleDuration = 10000;
var sampleMsPerFrame = msPerFrame / sampleDuration;
var reusedTuple = [0, 0];
function Springer(tension, wobble) {
    var _a;
    if (tension === void 0) { tension = 0.5; }
    if (wobble === void 0) { wobble = 0.5; }
    var stiffness = Math.min(Math.max(350 * tension, 20), 350);
    var damping = Math.min(Math.max(40 - 40 * wobble, 1), 40);
    var steps = [];
    var progress = 0;
    var velocity = 0;
    while (progress !== sampleDuration || velocity !== 0) {
        _a = __read(stepper(progress, sampleDuration, velocity, stiffness, damping), 2), progress = _a[0], velocity = _a[1];
        steps.push(progress / sampleDuration);
    }
    return function (i) {
        return steps[Math.ceil(i * (steps.length - 1))];
    };
}
exports.default = Springer;
// Inspired by https://github.com/chenglou/react-motion/blob/master/src/stepper.js
function stepper(value, destination, velocity, stiffness, damping) {
    var spring = -stiffness * (value - destination);
    var damper = -damping * velocity;
    var a = spring + damper;
    var newVelocity = velocity + a * sampleMsPerFrame;
    var newValue = value + newVelocity * sampleMsPerFrame;
    if (Math.abs(newVelocity) < 1 && Math.abs(newValue - destination) < 1) {
        reusedTuple[0] = destination;
        reusedTuple[1] = 0;
        return reusedTuple;
    }
    reusedTuple[0] = newValue;
    reusedTuple[1] = newVelocity;
    return reusedTuple;
}
// MIT License
// Copyright (c) 2016 Tanner Linsley
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//# sourceMappingURL=springer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableContainer/utils/springer.js
// module id = 1011
// module chunks = 8